var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpen = function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.006,
    d: "M19.242 13.033v6.217s.055.911-.147 1.221c-.367.529-1.211.529-1.211.529H4.452s-.66.018-1.1-.365c-.405-.346-.35-.948-.35-.948V9.277s0-.802.276-1.112c.367-.42 1.009-.365 1.009-.365h2.716"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#374255",
    d: "M21 8.488c-.11.127-.202.273-.312.4-1.505 1.532-2.991 3.064-4.496 4.595-.146.164-.33.274-.569.219-.275-.055-.44-.273-.44-.583v-2.206c-.018-.037-.018-.037-.037-.037-1.302-.073-2.569.073-3.725.711a5.86 5.86 0 0 0-2.403 2.407c-.037.073-.055.127-.11.2a.52.52 0 0 1-.588.2.52.52 0 0 1-.403-.455c-.019-1.057-.037-2.115.312-3.136.899-2.625 2.734-4.248 5.505-4.813.44-.091.917-.091 1.376-.128.018 0 .036 0 .073-.018v-.182c0-.657.018-1.295 0-1.951 0-.328.092-.565.404-.711h.275c.129.091.275.182.385.292a1028 1028 0 0 1 4.441 4.54c.11.127.22.273.312.4z"
  })));
};
export default SvgOpen;